const CARGO_TYPE = {
  bulk: 'Bulk',
  breakbulk: 'Breakbulk',
};

export default CARGO_TYPE;
